// shell/header/header.model.ts

import { GeoNetworkTool } from '@models/general/GeoNetworkTool';

export const COVARIATE_TAB = 'covariates';
export const DISEASES_TAB = 'diseases';
export const GEONETWORK_URL = 'https://mood-geonetwork.avia-gis.com/geonetwork/srv/eng/catalog.search#/metadata/';

export interface HeaderTool {
  label: string;
  route: string;
  external?: boolean;
  params?: Record<string, string>;
}

export type HeaderToolCategoryLabel = 'Text Mining' | 'Normalisation' | 'Risk Mapping' | 'Other Tools';

export interface HeaderToolCategory {
  label: HeaderToolCategoryLabel;
  tools: GeoNetworkTool[];
}

export const DEFAULT_CATEGORIES: HeaderToolCategory[] = [
  { label: 'Text Mining', tools: [] },
  { label: 'Normalisation', tools: [] },
  { label: 'Risk Mapping', tools: [] },
  { label: 'Other Tools', tools: [] },
];
